import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, X, ShoppingBag } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export default function Cart() {
  const { cart, updateQty, removeItem, cartTotal } = useStore();
  const nav = useNavigate();

  if (cart.length === 0) {
    return (
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8 py-24 min-h-[70vh] flex flex-col items-center justify-center text-center">
        <ShoppingBag strokeWidth={1} className="w-12 h-12 text-muted-foreground mb-6" />
        <h1 className="font-serif-display text-4xl font-light mb-4">Your bag is empty</h1>
        <Link to="/shop" className="label-caps border-b border-ink pb-1 hover:text-wine hover:border-wine transition-colors" data-testid="empty-cart-shop">Continue shopping</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1600px] mx-auto px-5 sm:px-8 py-16 min-h-[70vh]">
      <h1 className="font-serif-display text-5xl font-light tracking-tighter mb-12">Your bag</h1>
      <div className="grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 divide-y divide-line border-t border-line" data-testid="cart-items">
          {cart.map((item, i) => (
            <div key={i} className="flex gap-5 py-6" data-testid={`cart-item-${i}`}>
              <div className="w-24 h-32 bg-surface overflow-hidden shrink-0">
                {item.image ? <img src={fileUrl(item.image)} alt={item.name} className="img-cover" /> : null}
              </div>
              <div className="flex-1 flex flex-col">
                <div className="flex justify-between gap-4">
                  <div>
                    <h3 className="font-serif-display text-xl">{item.name}</h3>
                    <p className="label-caps text-muted-foreground mt-1">{[item.color, item.size].filter(Boolean).join(" / ")}</p>
                  </div>
                  <button onClick={() => removeItem(i)} data-testid={`remove-item-${i}`} className="text-muted-foreground hover:text-ink transition-colors"><X strokeWidth={1.5} className="w-5 h-5" /></button>
                </div>
                <div className="mt-auto flex justify-between items-end">
                  <div className="flex items-center border border-line">
                    <button onClick={() => updateQty(i, item.quantity - 1)} className="w-9 h-9 flex items-center justify-center hover:bg-surface" data-testid={`cart-minus-${i}`}><Minus strokeWidth={1.5} className="w-3.5 h-3.5" /></button>
                    <span className="w-8 text-center text-sm">{item.quantity}</span>
                    <button onClick={() => updateQty(i, item.quantity + 1)} className="w-9 h-9 flex items-center justify-center hover:bg-surface" data-testid={`cart-plus-${i}`}><Plus strokeWidth={1.5} className="w-3.5 h-3.5" /></button>
                  </div>
                  <p className="font-serif-display text-xl">${(item.price * item.quantity).toFixed(0)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="lg:col-span-1">
          <div className="bg-surface p-8 sticky top-24">
            <h2 className="font-serif-display text-2xl mb-6">Summary</h2>
            <div className="flex justify-between mb-3 text-sm"><span className="text-muted-foreground">Subtotal</span><span data-testid="cart-subtotal">${cartTotal.toFixed(0)}</span></div>
            <div className="flex justify-between mb-6 text-sm"><span className="text-muted-foreground">Shipping</span><span>Calculated at checkout</span></div>
            <div className="flex justify-between border-t border-line pt-4 mb-8"><span className="label-caps">Total</span><span className="font-serif-display text-2xl">${cartTotal.toFixed(0)}</span></div>
            <button onClick={() => nav("/checkout")} className="w-full bg-ink text-pearl py-4 label-caps hover:bg-wine transition-colors" data-testid="checkout-btn">Proceed to checkout</button>
          </div>
        </div>
      </div>
    </div>
  );
}
